import React, {useEffect, useState} from 'react';
import {Button, SelectChangeEvent, Stack, useMediaQuery} from '@mui/material';
import TitleMenu from "components/TitleMenu";
import Categories from "pages/Faq/components/Category";
import MultipleSelect from "components/MultipleSelect";
import Select from "components/Select";
import FilterTitle from "components/FilterTitle";
import {useQuestionListContext} from "pages/Faq/context/questionContext";
import ArchiveCheckbox from "components/Checkbox";


const Filters: React.FC = () => {
	const isDesktop = useMediaQuery(theme => theme.breakpoints.up('xl'))

	const {
		tagList,
		setSelectedTags,
		selectedTags,
		categoryList,
		selectedSubCategory,
		setSelectedCategory,
		setSelectedSubCategory,
		selectedCategory,
		setArchivedChecked
	} = useQuestionListContext();
	const [tags, setTags] = useState<string[]>([]);
	const [checked, setChecked] = useState<boolean>(false);


	const onClear = () => {
		setSelectedTags([]);
		setTags([]);
		setArchivedChecked(false);
		setChecked(false);
	}


	useEffect(() => {
		if (selectedTags?.length === 0) setTags([])
	}, [selectedTags?.length])

	const handleSetFilter = () => {
		setSelectedTags(tags);
		setArchivedChecked(checked);
	}

	if (isDesktop) return (
		<Stack spacing={3}>
			<TitleMenu>Категории</TitleMenu>
			<Categories/>
			<FilterTitle onClear={onClear}/>
			<ArchiveCheckbox label="Показать архивные вопросы" checked={checked} setIsChecked={setChecked}/>
			<MultipleSelect options={tagList || []} label={'Теги'} selectedTags={tags} setSelectedTags={setTags}/>
			<Button color={'primary'} variant={'contained'} onClick={handleSetFilter}>
				Применить
			</Button>
		</Stack>
	);

	const subCategories = selectedCategory?.subcategories?.map((value) => {
		return {id: value.id, title: value.name}
	});

	const handleChangeCategory = (event: SelectChangeEvent<string>) => {
		setSelectedSubCategory(null);
		setSelectedCategory(categoryList?.find(tag => tag.id === event.target.value) || null);
	}

	const handleChangeSubCategory = (event: SelectChangeEvent<string>) => {
		setSelectedSubCategory(event.target.value);
	}

	const selectedSubCategoryName: (id: string) => string = (id) => {
		const value = selectedCategory?.subcategories?.find(tag => tag.id === id)?.name;
		return value ?? '';
	}

	return (
		<>
			<Select label={'Категории'} options={categoryList || []} setSelected={handleChangeCategory}	selected={selectedCategory}/>
	  {(selectedCategory && selectedCategory.subcategories && selectedCategory.subcategories.length > 0) && (
		  <Select shouldAddMt label={'Подкатегория'} options={subCategories || []} setSelected={handleChangeSubCategory} selected={selectedSubCategory ? { id: selectedSubCategory, title: selectedSubCategoryName(selectedSubCategory) } : null}/>
	  )}
		</>
	)
};

export default Filters;
